import { connect } from 'react-redux';

import Actions from '../../Actions/Creators';
import InvitationRequest from './Component/InvitationRequest';


const mapStateToProps = (state, ownProps) => ({
    isLoading: state.auth.isComponentLoading,

    emailVerified: state.auth.emailVerified,
    emailAvailable: state.auth.ckeckEmailStatus,

    phoneVerified: state.auth.phoneVerified,
    phoneAvailable: state.auth.checkPhoneStatus,
    phoneMeta: state.auth.checkPhoneStatusMeta || {},

    checkValidationResponseType: state.auth.checkValidationResponseType,

    isMagicLinkUsed:  state.auth.isMagicLinkUsed,
    isMagicLinkSuccess:  state.auth.isMagicLinkSuccess,

    isInvitationLinkUsed: state.auth.isInvitationLinkUsed,
    isInvitationLinkSuccess: state.auth.isInvitationLinkSuccess,
    isInvitationLinkFailed: state.auth.isInvitationLinkFailed,

    userDetails: state.auth.invitationUserDetails || {},
    userAssociations: state.auth.invitationUserAssociations || [],
    invitationLink: state.auth.invitationLink,

});


const mapDispatchToProps = (dispatch) => ({

    handleInvitationRequest: (payload, associations) => dispatch(Actions.handleInvitationRequest(payload, associations)),

    checkEmailAvailability: (email) => dispatch(Actions.checkEmailAvailability(email)),
    checkPhoneNumberAvailability: (phone) => dispatch(Actions.checkPhoneNumberAvailability(phone)),

    sendInvitationLink: (config) => dispatch(Actions.postInvitationRequest(config)),

    changeValidationResponseType: (str) => dispatch(Actions.changeValidationResponseType(str)),
});


export default connect(mapStateToProps, mapDispatchToProps)(InvitationRequest)